// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__eS_wM","rootCenter":"LoadMoreObserver_rootCenter__lulwk","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__ZTJpy"};